export const LOGIN_SELECT_TYPE = '/member/login/select_type'
export const LOGIN_EMAIL = '/member/login/email'
export const LOGIN_2FA = '/member/login/2fa'
export const LOGIN_RESET_PASSWORD = '/member/login/reset_password'
export const REGISTER_SELECT_TYPE = '/member/register/select_type'
export const REGISTER_EMAIL = '/member/register/email'
export const REGISTER_FACEBOOK = '/member/register/facebook'
export const REGISTER_GOOGLE = '/member/register/google'
export const REGISTER_APPLE = '/member/register/apple'
export const REGISTER_PASSWORD_VERIFICATION = '/member/register/password_verification'
